import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  centsToDollars,
  dollarsToCents,
  removeReadOnlyFields,
} from 'src/utils/fieldNormalizers';

import { FranchiseFee } from './_types';
import { FranchiseDataParams } from './franchise-fee';

export function normalizeFranchiseFee(franchiseFee: any): FranchiseFee {
  const camelized = camelcaseKeys(franchiseFee, { deep: true });
  if (camelized.amount) {
    camelized.amount = centsToDollars(camelized.amount);
  }

  return camelized;
}

export function denormalizeFranchiseFee(
  franchiseFee: FranchiseFee | Partial<FranchiseFee> | FranchiseDataParams
): any {
  const decamelized = decamelizeKeys(franchiseFee, { deep: true });

  removeReadOnlyFields(decamelized, ['created_at', 'updated_at']);
  if (decamelized.amount) {
    decamelized.amount = dollarsToCents(decamelized.amount); // amount is an integer and so to support 2 decimal places on percentage we need to convert to cents
  }

  return decamelized;
}
